import { Navigate } from 'react-router-dom';

const RedireccionInicial = () => {
  return <Navigate to="/login" replace />;
};

export default RedireccionInicial;